import { call, put } from 'redux-saga/effects';
import serviceLocator, { SSAP_SVC } from '../../APIs/common/service-locator';
import { fetchCountriesFailure, fetchCountriesSuccess } from '../../actions/ssap/ssapActionCreators';
import { setCountries } from '../../actions/ssap/ssapActionCreators';

export function* countriesSaga() {
    try {
        const ssapService = yield call(serviceLocator, SSAP_SVC);
        const countries = yield call([ssapService, ssapService.getCountries]);
        if(countries) {
            yield put(fetchCountriesSuccess());
            yield put(setCountries(countries));
        } else {
            yield put(fetchCountriesFailure());
        }
    } catch(e) {
        yield put(fetchCountriesFailure());
    }
}